import { PropertyCard } from '@zillow/constellation';
import React from 'react';
import PropertyCardPlaceholder from '../../../images/property_card_placeholder.png';
import propertyUtils from '../../../utils/propertyUtils';
import { StyledBackground } from '../StyledComponents';

const PropertyCardPreview = ({ address = '', unit = '' }) => {
  const [street = '', city = '', stateAndZip = ''] = address.split(',');
  const [state = '', zip = ''] = stateAndZip.trim().split(' ');
  const { formattedCityStateZip, formattedCompleteAddress, formattedStreet } = propertyUtils.formatAddress({
    street: street.trim(),
    unit: unit.trim(),
    city: city.trim(),
    state: state.trim(),
    zip: zip.trim(),
  });

  return (
    <StyledBackground>
      <div style={{ maxWidth: '433px' }}>
        <PropertyCard
          aria-label={formattedCompleteAddress}
          badge={<PropertyCard.Badge>New property</PropertyCard.Badge>}
          data={{
            title: {
              children: <>{formattedStreet}</>,
              style: { marginTop: 24, marginLeft: 8 },
            },
            body1: {
              children: <>{formattedCityStateZip}</>,
              style: { marginBottom: 24, marginLeft: 8 },
            },
          }}
          photoBody={<PropertyCard.Photo src={PropertyCardPlaceholder} alt="placeholder property image" />}
          saveButton={<PropertyCard.SaveButton />}
        />
      </div>
    </StyledBackground>
  );
};

export default PropertyCardPreview;
